import { useDispatch, useSelector } from 'react-redux';
import EditableImage from '../../components/editable-image/EditableImage';
import { useProject } from '../project-hooks/useProject';
import { canUserEditProjectSelector } from '../../user/user-selectors';
import Image from '../../components/image/Image';
import styles from './edit-project-image.module.less';
import {
    cropTempProjectCoverPicture,
    removeProjectCoverPicture,
    uploadProjectCoverPictureForCropping,
} from '../project-actions';
import { showErrorModal } from '../../global-message/global-message-actions';
import ProjectVideo from '../project-video/ProjectVideo';

const EditProjectImage = ({ imageClass, ...props }) => {
    const project = useProject();
    const dispatch = useDispatch();

    const imageUploadHandler = (file) => dispatch(uploadProjectCoverPictureForCropping(project, file));
    const cropHandler = (crop) => dispatch(cropTempProjectCoverPicture(project, crop));
    const removeImageHandler = () => dispatch(removeProjectCoverPicture(project));
    const onDropRejected = () => dispatch(showErrorModal('Bildefilen du prøver å laste opp støttes ikke'));

    const canUserEditThisProject = useSelector((state) => canUserEditProjectSelector(state, project.id));

    if (project?.profile?.videoUrl) {
        return <ProjectVideo url={project?.profile?.videoUrl} loop={project?.profile?.videoLoop} />;
    }

    const EditableImagePlaceholder = (
        <div className={styles.dropImagePlaceholder}>
            <div className={styles.iconAndTitle}>
                <i className="fal fa-image fa-2x" aria-label={'Ikon av et landskapsbilde'} aria-hidden />
                <div>Legg til bilde (1200 x 624)</div>
            </div>
            <p className={styles.imagePlaceholderTips}>
                Bilder gjør seg best i liggende format. Vær varsom med bilder av barn.
            </p>
        </div>
    );

    const style = {};
    if (project.images?.cropData?.aspect) {
        style.aspectRatio = `${project.images.cropData.aspect}`;
    }

    let srcSet = null;
    if (project.images?.img_urls) {
        srcSet = `${project.images.img_urls.cropped500} 500w,
                  ${project.images.img_urls.cropped800} 800w,
                  ${project.images.img_urls.cropped1200} 1200w,
                  ${project.images.img_urls.cropped1800} 1800w
                `;
    }

    return (
        <EditableImage
            placeholder={EditableImagePlaceholder}
            uploadHandler={imageUploadHandler}
            cropHandler={cropHandler}
            removeImageHandler={removeImageHandler}
            src={project.img_url}
            tmpImage={project.img_tmp_url}
            editable={canUserEditThisProject}
            onDropRejected={onDropRejected}
            {...props}
        >
            <Image
                srcSet={srcSet}
                src={project.images?.img_urls?.cropped500 ?? project.img_url}
                alt={canUserEditThisProject ? `Prosjektbilde for ${project.title}` : ''}
                className={[styles.fullImage, imageClass].join(' ')}
                loading="eager"
                style={style}
            />
        </EditableImage>
    );
};

export default EditProjectImage;
